module.exports = __webpack_public_path__ + "static/media/chevsm.588a7d47.svg";